import React, { useEffect, useState } from 'react';
import { change as changeAction, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import * as validate from '@app/src/utils/validations';
import { renderInput } from '@app/src/common/Input';
import {
  fetchDistrictAction,
  setDistrictFullData,
  clearDistrictFullData
} from '@app/src/views/StepOne/form';
import { renderPredictive } from '@app/src/common/PredictiveInput';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  propertyId: number;
  activeColor?: string;
}

export const TitleDistrict: React.FC<Props> = ({ propertyId, activeColor }) => {
  const dispatch = useDispatch();
  const properties: SelectItemModel[] = useSelector(state => state.typeProperty.data);
  const propertiesAlias = ['decoracion', 'decoracion-electro', 'hogar', 'alfombra', 'banca-finanzas'];
  const propertyMatch = properties.filter(property => property && property.data && property.data.id === propertyId)[0];
  const isTitleInput = propertiesAlias.includes(propertyMatch && propertyMatch.data.alias);
  const print = useSelector(state => state.print.general);
  const currentTitle = useSelector(state => state.form.stepOne.values.title);
  const locations = useSelector(state => state.district.data);
  const [currentValue, setCurrentValue] = useState('');
  const locationSelected = useSelector(state => state.district.ubigeo);
  const message = useSelector(state => state.district.message);
  const isLoading = useSelector(state => state.district.isFetching);
  const lastWordFound = useSelector(state => state.district.inputValue);

  const handleChangePredictive = (data) => {
    if (data) {
      const { location, location_name } = data;
      dispatch(setDistrictFullData(location));
      dispatch(changeAction('stepOne', 'title', location_name));
      dispatch(changeAction('stepOne', 'districtName', location_name));
    }
  };

  const handleClickClose = () => {
    dispatch(changeAction('stepOne', 'title', ''));
    dispatch(changeAction('stepOne', 'districtName', ''));
    dispatch(clearDistrictFullData());
  };

  const handleChangeInput = (value) => {
    setCurrentValue(value);
  };

  const handleResize = () => {
    if (isClient && window.innerWidth < 768) {
      dispatch(fetchDistrictAction('lim'));
    }
  };

  useEffect(() => {
    if (currentValue) {
      dispatch(fetchDistrictAction(currentValue));
    }
  }, [currentValue]);

  useEffect(() => {
    if (print && print.title) {
      dispatch(changeAction('stepOne', 'title', print.title));
      if (print.ubigeo) {
        dispatch(setDistrictFullData(print.ubigeo));
        dispatch(changeAction('stepOne', 'districtName', print.districtName));
      }
    }
    isClient && window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      isClient && window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    if (print.property !== propertyId) {
      dispatch(clearDistrictFullData());
      dispatch(changeAction('stepOne', 'title', ''));
      dispatch(changeAction('stepOne', 'districtName', ''));
    }
  }, [propertyId]);

  return isTitleInput ?
    (
      <FieldForm label="Título de la publicación">
        <Field
          name="title"
          placeholder="Ej. Decoración"
          maxLength={50}
          component={renderInput}
          validate={[validate.required, validate.minLength3]}
          defaultValue={currentTitle}
        />
      </FieldForm>
    ) :
    (
      <FieldForm label="Distrito">
        <Field
          name="title"
          dataList={locations}
          handleChange={handleChangePredictive}
          handleChangeInput={handleChangeInput}
          handleClickClose={handleClickClose}
          activeColor={activeColor}
          defaultUbigeo={locationSelected}
          placeholder="Ingrese un distrito"
          isLoading={isLoading}
          component={renderPredictive}
          validate={[validate.required]}
          message={message}
          isLoadingModal={isLoading}
          minCharForSearch={3}
          lastWordFound={lastWordFound}
        />
      </FieldForm>
    )
};
